import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp, FiFilter } from "react-icons/fi";

const QuizFilter = ({ category, setCategoryResponse }) => {
  console.log('category', category);
  const [expandedCategory, setExpandedCategory] = useState("SSC Exams");
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(true);

  const categories = [
    {
      label: "SSC Exams",
      count: "10.8k",
      subExams: ["SSC CGL", "SSC CHSL", "SSC MTS", "SSC GD", "SSC CPO"]
    },
    {
      label: "Railways Exams",
      count: "6.7k",
      subExams: ["RRB NTPC", "RRB Group D", "RRB ALP", "RRB JE"]
    },
    {
      label: "Police Exams",
      count: "7.4k",
      subExams: ["Delhi Police He...", "UP Police Const...", "MP Police"]
    },
  ];

  const toggleCategory = (label) => {
    setExpandedCategory(expandedCategory === label ? null : label);
  };

  return (
    <div className="w-full lg:w-[233px] lg:sticky lg:top-[88px] bg-white border border-[#E0E0E0] rounded-[4px] overflow-hidden shadow-sm shrink-0 h-fit transition-all duration-300 mb-6 lg:mb-0">
      <div
        onClick={() => setIsMobileFilterOpen(!isMobileFilterOpen)}
        className="bg-[#4096F6] text-white py-3 px-4 text-[16px] md:text-[18px] font-semibold font-inter flex justify-between items-center cursor-pointer lg:cursor-default"
      >
        <div className="flex items-center gap-2">
          <FiFilter className="lg:hidden" />
          <span>For You</span>
        </div>
        <div className="lg:hidden">
          {isMobileFilterOpen ? <FiChevronUp /> : <FiChevronDown />}
        </div>
      </div>

      <div className={`flex flex-col ${isMobileFilterOpen ? 'max-h-[1000px]' : 'max-h-0'} lg:max-h-none overflow-hidden transition-all duration-500`}>
        {category.map((item) => {
          const isExpanded = expandedCategory === item._id;

          return (
            <div key={item._id} className="border-b border-[#3333331A] last:border-0">
              <div
                onClick={() => toggleCategory(item._id)}
                className={`flex justify-between items-center py-3 md:py-4 px-4 cursor-pointer transition-colors hover:bg-gray-50 ${isExpanded ? 'bg-[#F9FAFB]' : ''}`}
              >
                <div className="flex items-center gap-2">
                  <span className="text-[15px] md:text-[17px] font-medium text-[#333] font-inter">{item.name}</span>
                  <span className="text-[12px] md:text-[13px] text-[#33333399] font-medium font-inter">({item.totalQuizzes})</span>
                </div>
                {isExpanded ? <FiChevronUp className="text-gray-400" /> : <FiChevronDown className="text-gray-400" />}
              </div>

              {isExpanded && (
                <div className="bg-[#F8FAFC] pb-2 animate-in slide-in-from-top-2 duration-300">
                  {item.subCategories.map((exam) => (
                    <div onClick={() => setCategoryResponse(exam.name)}
                      key={exam._id}
                      className="py-2.5 px-6 md:px-8 text-[14px] md:text-[15px] text-[#333333B2] font-medium hover:text-[#4096F6] hover:bg-blue-50 cursor-pointer transition-all font-inter border-l-4 border-transparent hover:border-[#4096F6]"
                    >
                      {exam.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuizFilter;